import React from 'react'

const RecurrenceDialogRow = ({
  title,
  ...props
}) => {
  return (
    <div
      style={{ display: 'flex', height: '48px', flexDirection: 'row',
        alignItems: 'center' }}>
      <span
        style={{ width: 100, marginRight: 10, textAlign: 'right' }}>
        {title + ':'}
      </span>

      {props.children}
    </div>
  )
}

export default RecurrenceDialogRow



// WEBPACK FOOTER //
// ./src/schedule/common/modules/date/RecurrenceDialogRow.js